import React from "react";
import { css } from "@emotion/react";
import { Font, FieldLabel } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { siteUrlValidation } from "@/components/validations";
import { FormErrorMessage, FormTextField } from "@/components/molecules";

type Props = {
  name: string;
  labelRequired: boolean;
};

const siteUrlFormField = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <FieldLabel
          isRequired={props.labelRequired}
          helpMessage={
            <Font variant="s">
              会社ホームページなどの自社に関するWebサイトのURLを入力してください。
            </Font>
          }
        >
          ホームページ
        </FieldLabel>
      </div>
      <div css={inputWrapper}>
        <FormTextField
          name={props.name}
          placeholder={"例）https://example.com"}
          registerOptions={{
            validate: siteUrlValidation,
          }}
          ref={ref}
        />
        <div css={errorWrapper}>
          <FormErrorMessage name={props.name} />
        </div>
      </div>
    </div>
  );
};

export const SiteUrlFormField = React.forwardRef(siteUrlFormField);

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  flex: 1,
});

const errorWrapper = css({
  flex: 1,
});
